import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { refreshStaleBuild } from './utils/appFreshness'
import { installChunkRecovery } from './utils/chunkRecovery'

refreshStaleBuild()
installChunkRecovery(router)

const app = createApp(App)
app.use(router)

// 保留 index.html 中的首屏加载页，直到首次路由守卫和异步组件均准备完成。
// 这样访问受保护首页时不会在身份校验期间出现空白页面。
const mountApp = async () => {
  try {
    await router.isReady()
  } catch (error) {
    console.error('首次路由初始化失败:', error)
  }
  app.mount('#app')
}

mountApp()
